"use client"

import { useMemo } from "react"
import { useFrontendPreferences } from "@lib/frontend-preferences"
import { HttpTypes } from "@medusajs/types"
import { sortProducts } from "@lib/util/sort-products"
import ProductPreview from "@modules/products/components/product-preview"
import { Pagination } from "@modules/store/components/pagination"
import { useCatalogSort } from "@modules/store/components/refinement-list/catalog-sort-context"

const PRODUCT_LIMIT = 12

type SortedProductGridProps = {
  products: HttpTypes.StoreProduct[]
  region: HttpTypes.StoreRegion
  page: number
}

export default function SortedProductGrid({
  products,
  region,
  page,
}: SortedProductGridProps) {
  const { t } = useFrontendPreferences()
  const { sortBy } = useCatalogSort()
  const sortedProducts = useMemo(
    () => sortProducts(products, sortBy),
    [products, sortBy]
  )
  const totalPages = Math.ceil(sortedProducts.length / PRODUCT_LIMIT)
  const safePage = Math.min(Math.max(page, 1), Math.max(totalPages, 1))
  const pageStart = (safePage - 1) * PRODUCT_LIMIT
  const visibleProducts = sortedProducts.slice(
    pageStart,
    pageStart + PRODUCT_LIMIT
  )

  return (
    <>
      <p className="sahil-catalog__count">
        {t.catalog.results.replace("{count}", String(sortedProducts.length))}
      </p>
      <ul
        className="sahil-grid"
        data-testid="products-list"
      >
        {visibleProducts.map((product) => (
          <li key={product.id}>
            <ProductPreview product={product} region={region} />
          </li>
        ))}
      </ul>
      {totalPages > 1 && (
        <Pagination
          data-testid="product-pagination"
          page={safePage}
          totalPages={totalPages}
        />
      )}
    </>
  )
}
